import {
  wwwMobileNavAnimateState,
  wwwMobileNavPanelClass,
} from '../lib/wwwMobileNav';

/**
 * Keep-mounted overlay for the www hamburger. Visibility only, so opening
 * or choosing a link does not fade a layer over the page background.
 */
export default function WwwMobileNavPanel({ open, id, children }) {
  return (
    <div
      id={id}
      data-state={wwwMobileNavAnimateState(open)}
      className={wwwMobileNavPanelClass(open)}
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      {children}
    </div>
  );
}
